/**
 * TODO(prod): remove before the first production release — the URL param is the
 * only gate, so any environment, production included, serves the demo case to a
 * session that asks for it (ARCH-024).
 */
export const isMockCaseEnabled = (): boolean =>
  new URLSearchParams(window.location.search).get('mockCase') === 'true';
